import { Suspense } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';

import { GreetingCard } from 'APP/GreetingCard/GreetingCard';
import { Modules } from 'APP/Modules/Modules';
import { MainView } from 'APP/main/MainView';
import { ForceUpdate } from 'APP/pages/ForceUpdate/ForceUpdate';
import { AuthorizationView } from 'APP/pages/authorization/AuthorizationView/AuthorizationView';
import { BlockedView } from 'APP/pages/authorization/BlockedView/BlockedView';
import { UntrustedView } from 'APP/pages/authorization/UntrustedView/UntrustedView';
import { DeepLinkView } from 'APP/pages/deepLink/DeepLinkView/DeepLinkView';
import { APP_AUTHORIZATION_ROUTES_FOR_ROUTER } from 'APP/router/AppRouter.authorizationRoutes';
import { UnauthorizedView } from 'APP/unauthorized/UnauthorizedView';

import { PrivateDomain } from './PrivateDomain/PrivateDomain';
import { PublicDomain } from './PublicDomain/PublicDomain';
import { RouterLink } from './constants';

export const APP_ROUTES: RouteObject[] = [
  {
    path: `${RouterLink.Login}/*`,
    Component: AuthorizationView,
    children: APP_AUTHORIZATION_ROUTES_FOR_ROUTER,
  },
  {
    path: `${RouterLink.Untrusted}/*`,
    Component: UntrustedView,
  },
  {
    path: `${RouterLink.Blocked}/*`,
    Component: BlockedView,
  },
  {
    path: `${RouterLink.Unauthorized}/*`,
    element: (
      <Suspense fallback={<div />}>
        <PublicDomain redirectTo={RouterLink.Main}>
          <UnauthorizedView />
        </PublicDomain>
      </Suspense>
    ),
  },
  {
    path: `${RouterLink.Deeplink}/*`,
    element: (
      <PublicDomain isAllowed>
        <DeepLinkView />
      </PublicDomain>
    ),
  },
  {
    path: RouterLink.GreetingCard,
    element: (
      <Suspense fallback={<div />}>
        <GreetingCard />
      </Suspense>
    ),
  },
  {
    path: RouterLink.ForceUpdate,
    element: <ForceUpdate />,
  },
  {
    path: '*',
    element: (
      <PrivateDomain redirectTo={RouterLink.Login}>
        <MainView />
      </PrivateDomain>
    ),
  },
];

export const BASE_ROUTE: RouteObject = {
  element: (
    <>
      <Modules />
      <Outlet />
    </>
  ),
  children: APP_ROUTES,
};
